import React from 'react'
import RequestAccessFormPart from '../../react4xp/components/FormPages/RequestAccessForm'
import { country_list } from '/lib/modules/util/constants'

function RequestAccessForm({ breadcrumbs, title, intro, emailServiceUrl, documentAccessDetails, privacyPolicyCheckboxRichText, recaptchaSiteKey, recaptchaValidationUrl }) {
    return (
        <RequestAccessFormPart
            siteKey={recaptchaSiteKey}
            validationRecaptchaUrl={recaptchaValidationUrl}
            accessContentId={documentAccessDetails.contentId}
            topInfos={{ title, intro }}
            form={{
                endpoint: emailServiceUrl,
                onSuccess: () => console.log('Sending email...'),
                onError: () => console.error('Error sending email')
            }}
            steps={{
                step1: {
                    title: documentAccessDetails.title,
                    fileName: documentAccessDetails.fileName
                },
                step2: {
                    title: 'Fill in your details',
                    inputs: [
                        {
                            type: 'input',
                            input: {
                                type: 'text',
                                id: 'first-name',
                                name: 'First name',
                                label: 'First name',
                                required: true,
                                errorMessages: {
                                    required: 'This field is required.'
                                }
                            }
                        },
                        {
                            type: 'input',
                            input: {
                                type: 'text',
                                id: 'last-name',
                                name: 'Last name',
                                label: 'Last name',
                                required: true,
                                errorMessages: {
                                    required: 'This field is required.'
                                }
                            }
                        },
                        {
                            type: 'input',
                            input: {
                                type: 'text',
                                id: 'company-name',
                                name: 'Company name',
                                label: 'Company name',
                                required: true,
                                errorMessages: {
                                    required: 'This field is required.'
                                }
                            }
                        },
                        {
                            type: 'input',
                            input: {
                                type: 'email',
                                id: 'email',
                                name: 'Email',
                                label: 'Email',
                                required: true,
                                errorMessages: {
                                    required: 'This field is required.',
                                    invalidEmail: 'Invalid email format.'
                                }
                            }
                        },
                        {
                            type: 'input',
                            input: {
                                type: 'tel',
                                id: 'telephone',
                                name: 'Telephone',
                                label: 'Telephone',
                                required: true,
                                errorMessages: {
                                    required: 'This field is required.'
                                }
                            }
                        },
                        {
                            type: 'select',
                            select: {
                                id: 'country',
                                name: 'Country',
                                label: 'Country',
                                defaultValue: 'Choose country',
                                options: country_list,
                                required: true,
                                errorMessages: {
                                    required: 'This field is required.'
                                }
                            },
                        },
                        {
                            type: 'textarea',
                            textarea: {
                                id: 'business-relationship',
                                name: 'Business relationship',
                                label: 'Business relationship',
                                placeholder: 'Write your comment here...',
                                required: true,
                                errorMessages: {
                                    required: 'This field is required.'
                                }
                            }
                        }
                    ]
                }
            }}
            privacyCheckbox={{
                name: 'terms',
                required: true,
                errorMessages: {
                    required: 'This field is required.'
                },
                text: privacyPolicyCheckboxRichText
            }}
            submit={{
                label: 'Submit',
                successMessage: 'Your form has been submitted successfully.'
            }}
        />
    )
}

export default RequestAccessForm